const NS = 'TopicHeroBannerBlock';
const CLS = 'topicHeroBannerBlock';

import { scrollIntoView } from 'scroll-js';

import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';
import { compactViewMixinBlock } from '../../mixins/compactViewMixinBlock/compactViewMixinBlock';

export class TopicHeroBannerBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$scrollToButton = this.$element.find(`.${CLS}-scrollTo`);
		this.$scrollToButton.on('click', () => {
			scrollIntoView(this.$element.next(`[class*='Block']`)[0], $('.tpl-scroller')[0], { duration: 750, easing: 'ease-in-out' });
		});

		this.initCompactView(this);
		this.initFullWindowHeight(this);
	}
}

Object.assign(TopicHeroBannerBlock.prototype, compactViewMixinBlock);
Object.assign(TopicHeroBannerBlock.prototype, fullWindowHeightMixinBlock);
